export const selectGetDeposits = state => state.deposits.deposits
export const selectGetTotalDeposits = state => state.deposits.totalDeposits
export const selectGetAdminDeposits = state => state.deposits.adminDeposits
export const selectGetCreatedDeposit = state => state.deposits.deposit
export const selectGetAssociated = state => state.deposits.associated
export const selectReceipt = state => state.deposits.receipt
export const selectReference = state => state.deposits.reference
export const selectDeposit = state => state.deposits.depositData
